module.exports = __webpack_public_path__ + "static/media/lock.c87e4d91.png";